import { PdfBarcodeComponent } from '../../PdfComponent';
import React from 'react';
import { DropdownSearchSelect } from '../../../../components/Dropdown';
import { usePdfTemplateContext } from '../../PdfTemplateEditorContext';
import PdfTemplateComponentDefault from '../properties/PdfTemplateComponentDefault';
import { PdfFieldResolving } from '../../data/PdfFieldResolving';
import { PdfDataKey } from '../../data/PdfDataKey';

interface PdfTemplateBarcodeComponentPropertiesProps {
  component: PdfBarcodeComponent;
}

export default function PdfTemplateBarcodeComponentProperties<T>({
  component,
}: PdfTemplateBarcodeComponentPropertiesProps) {
  const { dataKeys, updateComponent, data } = usePdfTemplateContext<T>();

  return (
    <div className='grid gap-2'>
      <PdfTemplateComponentDefault component={component} />

      <p className='section-title mt-2'>Content</p>
      <DropdownSearchSelect<PdfDataKey<any>>
        placeholder={'Select field to populate'}
        items={dataKeys}
        textBuilder={key => PdfFieldResolving.getLabel(key, data)}
        onSelect={key => updateComponent(component.id, { key })}
        value={component.key}
        label={'Field to populate'}
      />
    </div>
  );
}
